<template>
  <div
    v-if="images.length"
    class="review-card-images d-flex flex-wrap"
  >
    <button
      v-for="(image, index) in images"
      :key="image.id ?? image.src"
      type="button"
      class="review-card-images__btn"
      @click.stop.prevent="$emit('open', index)"
    >
      <img
        class="review-card-images__image"
        :src="image.previewSrc"
        alt=""
        loading="lazy"
      >
      <span class="review-card-images__hover ui-icon-search bg-gray-0--text" />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import type { CoreImageLightboxItem } from 'src/core/CoreImageLightbox/types'
import type { Rate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'
import { getMediaUrl } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/getMediaUrl'
import getRateImages from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/getRateImages'

type ReviewImageItem = CoreImageLightboxItem & {
  previewSrc: string
}

const props = defineProps<{
  rate: Rate
}>()

defineEmits(['open'])

const { context }: CommonContextStore = useContextStore()

const images = computed<ReviewImageItem[]>(() => getRateImages(props.rate).map(image => {
  const previewSrc = getMediaUrl(image.img_s, context)
  const src = getMediaUrl(image.img_l, context) || previewSrc

  return {
    id: image.id,
    src,
    previewSrc,
    alt: '/',
  }
}))

defineExpose({ images })
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.review-card-images {
  &__hover {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: rgba($ui-kit-primary, 0.5);
    transition: 0.2s ease-in-out opacity;
  }

  &__btn {
    position: relative;
    display: inline-block;
    width: 80px;
    height: 86px;
    margin: 0 12px 0 0;
    padding: 0;
    overflow: hidden;
    border: 0;
    border-radius: $border-radius-sm;
    background: transparent;
    cursor: pointer;

    &:hover .review-card-images__hover {
      opacity: 1;
    }
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
